import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BookIcon from "../../../assets/Dashboard/icons/BookIcon.tsx";
import BestPracticesPopup from "../../../pages/NewTG/Models/Popups/BestPractices/BestPracticesPopup.tsx";
import { isLegacyTgRoute } from "../../../pages/NewTG/utils/tg-utils.ts";
import BriaButton, { ButtonTypes } from "../BriaButton/BriaButton";
import styles from "./BestPractisesButton.module.scss";

export type BestPractisesButtonProps = {
	fontSize?: "small" | "medium";
	className?: any;
	hideIcon?: boolean;
	buttonType?: ButtonTypes;
};

const BestPractisesButton = ({
	fontSize = "medium",
	className,
	hideIcon = false,
	buttonType,
}: BestPractisesButtonProps) => {
	const { t } = useTranslation("common", { keyPrefix: "tabsLayout.buttons" });
	const [open, setOpen] = useState(false);

	const getFontSize = () => {
		switch (fontSize) {
			case "small":
				return styles.smallFont;
			case "medium":
				return styles.mediumFont;
			default:
				return styles.mediumFont;
		}
	};

	if (!isLegacyTgRoute()) return null;

	return (
		<>
			<BriaButton
				className={`${styles.bestPracticesButton} ${className ?? ""} ${getFontSize()}`}
				onClick={() => setOpen(true)}
				startIcon={hideIcon ? undefined : <BookIcon className={styles.icon} />}
				buttonType={buttonType as any}
			>
				{t("bestPractices")}
			</BriaButton>
			<BestPracticesPopup open={open} onClose={() => setOpen(false)} />
		</>
	);
};

export default observer(BestPractisesButton);
